import React from 'react';
import { portfolioData } from '../../data/portfolioData';
import './Experience.css';

const Experience = () => {
  const { experiences } = portfolioData;

  return (
    <section id="experience" className="experience section-bg">
      <div className="container">
        <h2>Work Experience</h2>
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={exp.id} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3>{exp.title}</h3>
                  <span className="company">{exp.company}</span>
                  <span className="period">{exp.period}</span>
                </div>
                <div className="location">{exp.location}</div>
                
                {exp.description && (
                  <p className="job-description">{exp.description}</p>
                )}
                
                {exp.achievements && (
                  <div className="achievements">
                    <h4>Key Achievements:</h4>
                    <ul>
                      {exp.achievements.map((achievement, idx) => (
                        <li key={idx}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                {exp.technologies && (
                  <div className="technologies">
                    {exp.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;